export default __webpack_public_path__ + "media/food.267bc1b1f55e73ca0caad74bf7128ca5.webp";